'use strict';

import register from './core';
import '../functions/jquery-global';
import Handlebars from 'handlebars/dist/handlebars';
import { isValidPhrase, keys } from '../functions/search-common';

register('autocomplete', function (element) {

  var autocompleteList = 'autocomplete__list'
  //hide autocomplete when using cludo search since it has its own  
  if ($(element).attr('data-searchprovider') === 'cludo') {
    autocompleteList = 'autocomplete__list hide';
  }

  var $label = $(element).addClass('autocomplete'),
    rekaiActive = false, //(typeof __rekai !== "undefined"),
    $input = $label.find('input').attr('autocomplete', 'off'),
    $list = $('<ul id="autocomplete-list" role="listbox"></ul>').addClass(autocompleteList),
    $document = $(document),
    autoCompleteButton = '.autocomplete__button',
    autoCompleteButtonActive = 'autocomplete__button--active',
    autoCompleteResultTemplate = Handlebars.compile($('#autocomplete-template').html()),
    autoCompleteData = $label.data(),
    url = window.location.origin + (autoCompleteData.url === undefined ? window.location.pathname : autoCompleteData.url),
    isResultPage = autoCompleteData.url === undefined || autoCompleteData.returntopage === true,
    timeout = null,
    rekAutocomplete = null,
    listIndex = -1,
    active = false,
    currentLang = $('html').attr('lang'),
   closeAutoComplete = function () {
    active = false;
    $document.off('click.autocomplete');
    $list.html('');
    listIndex = -1;
  },
    goToSearchResultPage = function () {
      var queryValue = $input.val().trim();
      if (isResultPage) {
        closeAutoComplete();
        $label.closest('form').trigger('submit');
      }
      else
        window.location.href = url + '?q=' + queryValue;
    },
    getCurrentButtons = function () {
      return $list.find(autoCompleteButton);
    };

  if (rekaiActive) {
    __rekai.ready(function () {
      rekAutocomplete = rekai_autocomplete('#search-dropdown-input', { debug: true }, [{
        templates: {
          suggestion: function (suggestion) {
            return '<div class="rekai-suggestion-item">' + suggestion.title + '</div>';
          }
        }
      }])
        .on('rekai_autocomplete:selected', function (event, suggestion, dataset) {
          window.location = suggestion.url;
        });
    });
  }
  else {
    $label.append($list).on('click', autoCompleteButton, function () {
      getCurrentButtons().removeClass(autoCompleteButtonActive);
      $(this).addClass(autoCompleteButtonActive);
      $input.val($(this).text().trim());
      goToSearchResultPage();
    });

    $input.on('keyup', function (e) {
      clearTimeout(timeout);
      var kc = e.keyCode, val = $input.val();
      if (e.keyCode != keys.tab) {
        e.preventDefault();
      }
      var isArrowsPressed = (kc === keys.enter || kc === keys.escape || kc === keys.left || kc === keys.right || kc === keys.up || kc === keys.down || kc === keys.home || kc === keys.end);

      if (active && isArrowsPressed && isValidPhrase(val)) {
        if (kc === keys.escape)
          closeAutoComplete();
        else {
          var $buttons = getCurrentButtons();
          if (kc === keys.enter) {
            goToSearchResultPage();
          }
          else {
            var firstIndex = 0;
            var lastIndex = $buttons.length - 1;
            $buttons.removeClass(autoCompleteButtonActive);

            switch (kc) {
              case keys.home:
                listIndex = firstIndex;
                break;
              case keys.end:
                listIndex = lastIndex;
                break;
              case keys.down:
              case keys.right:
                listIndex++;
                break;
              case keys.up:
              case keys.left:
                listIndex--;
                break;
            }

            if (listIndex > lastIndex)
              listIndex = firstIndex;
            else if (listIndex < firstIndex)
              listIndex = lastIndex;

            if (listIndex !== -1)
              $input.val($buttons.eq(listIndex).addClass(autoCompleteButtonActive).text().trim());
          }
        }
      }
      else {
        closeAutoComplete();
        if (isValidPhrase(val)) {
          timeout = setTimeout(function () {
            val = $input.val();

            $.ajax({
              type: "GET",
              url: url + '/autocomplete/?q=' + val,
              headers: {
                'x-language': currentLang
              },
              success: function (data) {
                if (data.Result) {
                  $list.html(autoCompleteResultTemplate(data));
                  active = true;
                  $document.on('click.autocomplete', function (e) {
                    if (active && (!$input.is(e.target) && $input.has(e.target).length === 0))
                      closeAutoComplete();
                  });
                }
              }
            });
          }, 100);
        }
      }
    });
  }
});
